import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AccountingProfitLossTable from "../../components/AccountingProfitLossTable";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { getProfitandLoss, getSupportFund } from "../../api/dataCapture";
import { setProfitAndLossDetails, setSupportFundDetails } from "../../redux/reducers/dataCaptures";
import AccountingSupportFundTable from "../../components/AccountingSupportFundTable";
import AccountingProfitLossSummaryTable from "../../components/AccountingProfitLossSummaryTable";

const AccountingDetails = () => {
    const [isASFrow, setASFrow] = useState(false);
    const dispatch = useDispatch();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const profitAndLossDetails = useSelector((state:any) => state.dataCaptures.profitAndLossDetails);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    
    useEffect(() => {
        const fetchAccountingDetails = async () => {
            const response = await getProfitandLoss({clubId: clubDetails.id, isPast: false});
            const tempResponse = response?.map((d:any) => { return { ...d, tempId: Math.floor(Math.random() * 1001)+ 'T' } })
            dispatch(setProfitAndLossDetails(tempResponse));
            const res = await getSupportFund({clubId: clubDetails.id, isPast: false});
            const tempRes = res?.map((d:any) => { return { ...d, tempId: Math.floor(Math.random() * 1001)+ 'T' } })
            dispatch(setSupportFundDetails(tempRes));
        }
        fetchAccountingDetails();
    }, []);
    return (
        <>
        <Box className='liceDataSubContainer'>
            <Typography className='standardsHeading uppercase'>Accounting - Profit & Loss</Typography>
            <Box>
                <AccountingProfitLossTable />
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <AccountingProfitLossSummaryTable />
                </Box>
            </Box>
        </Box>
        <Box className='liceDataSubContainer'>
            <Typography className='standardsHeading uppercase'>{'Accounting (Support Fund)'}</Typography>
            <Box>
                <AccountingSupportFundTable addRow={isASFrow} handleClick={() => setASFrow(false)} />
                    {
                        !isAdmin &&
                        <Button className='smallButton' sx={{ float: 'right', mt: '10px' }} disableElevation disabled={isASFrow} variant='contained' size='small' onClick={() => setASFrow(true)} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                            {'Add other expense'}
                        </Button>
                    }
            </Box>
        </Box>
        </>
    )
}

export default AccountingDetails;